export const enterpriseLinkRoute = '/enterprise/link/';
export const enterpriseInviteRoute = '/enterprise/invites/send/';
export const enterpriseInviteBulkRoute = '/enterprise/invites/bulk/';

export const templateCreateCompanyROute =
  '/enterprise/template/create-company/';
export const templateCreateMultipleCompaniesRoute =
  '/enterprise/template/create-companies/';
export const tampleteCreateRoute = '/enterprise/template/create/';
export const tampleteEditRoute = '/enterprise/template/edit/';
export const tampleteIndustryEditRoute = '/enterprise/template/industries/add';
export const tampleteImagesEditRoute = '/enterprise/template/logo/';
export const tampleteGetRoute = '/enterprise/template/get/';
export const tampleteComapniesRoute = '/enterprise/template/get-companies/';
export const tampleteTagsRoute = '/enterprise/template/get-tags/';
export const tampleteComapnyUnassignRoute = '/enterprise/template/unassign/';
export const tampleteComapnyAssignRoute = '/enterprise/template/assign/';
export const tampleteCopyRoute = '/enterprise/template/clone/';
export const tampleteSavedMessagesRoute =
  '/enterprise/template/saved-messages/';
export const tampleteJobPostingRoute = '/enterprise/template/jobadd/';
export const tampleteJobUpdateRoute = '/enterprise/template/job/update/';
export const templeteIndustries = '/enterprise/template/industries/get';
export const templetePostQuestions = '/enterprise/template/questions/create/';
export const templeteUpdateQuestions = '/enterprise/template/questions/edit/';
export const templeteDeleteQuestions = '/enterprise/template/questions/delete/';
export const inviteCompanyRoute = '/enterprise/template/invite_employer/';
export const uploadCompaniesCsvRoute = '/enterprise/get-data/csv/';

// Hireflix Template Routes
export const templateHireflixGetJobsListingRoute =
  '/enterprise/template/job/listing/hireflix/';
export const templateHireflixAddVideoInterviewRoute =
  '/enterprise/template/hireflix/config/set/';
export const templateHireflixDeleteVideoInterviewRoute =
  '/enterprise/template/hireflix/config/delete/';

export const templateJobPositionsKey = 'templateJobPositions';
export const errorMessage = 'Sorry, something went wrong';
